export const customTheme= {
    components: {
        Table: {
            cellPaddingBlockSM: 4,
            cellFontSizeSM: 12,
            headerBg: '#151030',
            headerColor: '#fff',
            headerFilterHoverBg: '#151030',
            headerSortActiveBg: '#151030',
            headerSortHoverBg: '#151030',
            expandIconBg: '#fff'
        }
    }
};